import { gsap } from "gsap";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { MotionPathHelper } from "gsap/MotionPathHelper";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

//import gsapReveals from "./gsap-reveals.js";
import heroLine from "./hero-line.js";
import { scrollSpy } from "./page-sections.js";
import scrollToForm from "./scroll-to-form.js";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, DrawSVGPlugin, MotionPathHelper);

export default function siteAnimations() {
  //gsapReveals(gsap);

  if (document.querySelector('.enabled-sidenav')) {
    scrollSpy({
      ScrollTrigger: ScrollTrigger,
      gsap: gsap,
      elements: document.querySelectorAll("#page-sections .page-sections-content .page-section"),
      nav: document.querySelector("#page-sections .page-sections-navigation"),
      links: document.querySelectorAll("#page-sections .page-sections-navigation nav a"),
    });
  }

  scrollToForm(gsap);
  heroLine(gsap);
}

siteAnimations();
